import React, { Component, Fragment } from "react"

import Header from "../Header"
import messageSvg from "../../images/message.svg"
import "./index.less"
import {
  LOCAL_USER_ID,
  LOCAL_COMPANY_ID,
  LOCAL_ACTIVE_ROL,
} from "../../utils/storage"
import { testSnowplow } from "../Snowplow/config2"

class Layout extends Component {
  render() {
    /* initSnowplow(LOCAL_USER_ID(), LOCAL_COMPANY_ID(), LOCAL_ACTIVE_ROL()) */
    testSnowplow()

    const { children } = this.props

    const hideHeader = window.top !== window.self

    return (
      <Fragment>
        <Header />
        {/* minHeight: '93vh',  */}
        <div style={{ backgroundColor: "#f9f9f9", marginTop: hideHeader ? 0 : 54 }}>
          {children}
        </div>
        {/* <div className='message-icon'>
          <img src={messageSvg} />
        </div> */}
      </Fragment>
    )
  }
}

export default Layout
